"use client";

import React from "react";
import { Facebook, Instagram, Twitter, Youtube } from "lucide-react";
import { Link } from "@/components/common/Link";
import { WvcLogo } from "@/integrations/wordpress/WvcLogo";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { Button } from "@/components/ui/button";
import { Separator } from "@/components/ui/separator";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <ul className="flex flex-col gap-3">
        {[1, 2, 3, 4].map((_, i) => <li key={i} data-index={i}>
            <div className="h-5 w-24 bg-muted/10 animate-pulse rounded-md" />
          </li>)}
      </ul>;
  }
  if (!menuItems || menuItems.length === 0) {
    return <ul className="flex flex-col gap-3">
        <li data-index={0}>
          <Link to="/HomePage" className="text-muted-foreground hover:text-foreground transition-colors text-xs">
            Home
          </Link>
        </li>
        <li data-index={1}>
          <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors text-xs">
            Services
          </Link>
        </li>
        <li data-index={2}>
          <Link to="#" className="text-muted-foreground hover:text-foreground transition-colors text-xs">
            Location
          </Link>
        </li>
      </ul>;
  }
  return <ul className="flex flex-col gap-3">
      {menuItems.map((item, i) => <li key={item.id} data-index={i}>
          <Link to={item.href || "#"} className="text-muted-foreground hover:text-foreground transition-colors text-xs">
            {item.label}
          </Link>
        </li>)}
    </ul>;
}
function FooterMenu() {
  return <MenuProvider menu_id="footer_menu">
      <FooterMenuConsumer />
    </MenuProvider>;
}
export default function Footer() {
  const categories = [{
    name: "Full-Service Oil Changes",
    href: "#"
  }, {
    name: "Tire Sales & Repair",
    href: "#"
  }, {
    name: "Fluid & Safety Checks",
    href: "#"
  }];
  const socialLinks = [{
    icon: Facebook,
    href: "https://www.facebook.com/p/Kimball-Speedy-Lube-tire-service-100063499485842/",
    label: "Facebook"
  }, {
    icon: Twitter,
    href: "#",
    label: "Twitter"
  }, {
    icon: Instagram,
    href: "#",
    label: "Instagram"
  }, {
    icon: Youtube,
    href: "#",
    label: "YouTube"
  }];
  return <section data-section-id="259740" id="footer" className="dark bg-background text-foreground pt-16 pb-8">
      <div className="container mx-auto px-4 md:px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12 mb-8 md:mb-12">
          {}
          <div className="flex flex-col items-start">
            <Link to="/HomePage" className="mb-6 inline-block">
              <WvcLogo className="h-8 w-auto text-foreground" />
            </Link>
            <p className="text-muted-foreground text-xs leading-relaxed max-w-xs">
              Kimball Speedy Lube & Tires provides expert automotive maintenance and tire services in Jasper, TN. Fast, reliable, and professional care for your vehicle.
            </p>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-xs uppercase tracking-wider mb-6 text-foreground">
              Quick Links
            </h3>
            <FooterMenu />
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-xs uppercase tracking-wider mb-6 text-foreground">
              Our Services
            </h3>
            <ul className="flex flex-col gap-3">
              {categories.map((category, i) => <li key={category.name} data-index={i}>
                  <Link to={category.href} className="text-muted-foreground hover:text-foreground transition-colors text-xs">
                    {category.name}
                  </Link>
                </li>)}
            </ul>
          </div>

          {}
          <div>
            <h3 className="font-default font-bold text-xs uppercase tracking-wider mb-6 text-foreground">
              Connect
            </h3>
            <div className="flex gap-4 mb-8">
              {socialLinks.map((social, i) => {
              const Icon = social.icon;
              return <Link key={social.label} to={social.href} className="text-muted-foreground hover:text-destructive transition-colors" aria-label={social.label} data-index={i}>
                    <Icon className="size-5" />
                  </Link>;
            })}
            </div>
            <div className="space-y-4">
              <p className="text-xs text-muted-foreground">
                M-F 8am-5pm, Sat 8am-12pm. Visit us at 837 Kimball Crossing Dr.
              </p>
              <Button variant="destructive" asChild className="w-full rounded-md font-default font-bold uppercase text-xs">
                <Link to="/HomePage">Back to Top</Link>
              </Button>
            </div>
          </div>
        </div>

        <Separator className="bg-border mb-6" />

        {}
        <div className="flex flex-col md:flex-row justify-between items-center gap-4 text-xs text-muted-foreground">
          <p>© {new Date().getFullYear()} Kimball Speedy Lube & Tires. All rights reserved.</p>
          <div className="flex gap-6">
            <Link to="#" className="hover:text-foreground transition-colors">
              Privacy Policy
            </Link>
            <Link to="#" className="hover:text-foreground transition-colors">
              Terms of Service
            </Link>
          </div>
        </div>
      </div>
    </section>;
}